import { Autocomplete, FormHelperText, TextField, createFilterOptions } from "@mui/material";
import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { mainStore } from "../../store/MainStore";
import { Title } from "../Title";

const OneAutocomplete = ({
    fetchOptions,
    obj,
    placeholder="",
    label='',
    isHelperText=false,
}) => {
    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState([])
    const [isFetchingOptions, setIsFetchingOptions] = useState(false);

    const getError = () => obj?.error
    const setError = (error) => {
        obj.error = error
    }

    const loading = open && options.length === 0;
    useEffect(() => {
        let active = true;
    
        if (!loading) {
          return undefined;
        }

        (async () => {
          if (active) {
            const fetchedOptions = await fetchOptions()
            
            let optionsWithoutItem = fetchedOptions.filter(option=>option.id != obj.item?.id)
            
            setOptions(optionsWithoutItem);
          }
        })();

        setIsFetchingOptions(false)
    
        return () => {
          active = false;
        };
      }, [loading]);

    useEffect(() => {
        if (!open) {
            setOptions([]);
        }
    }, [open]);
    
    const filterOptions = createFilterOptions({
        matchFrom: 'any',
        stringify: (option) => option?.title.ru?.value + option?.title.eng?.value,
    });


    return (
      <div>
        <Title label={label} />
        <Autocomplete
            value={obj?.item || ''}
            onChange={(event, newValue) => {
              mainStore.isSaved = false
              obj.item = newValue
              setError(false)
            }}
            onOpen={() => {
              setIsFetchingOptions(true)
              setOpen(true);
            }}
            onClose={() => {
              setOpen(false);
            }}
            loading={isFetchingOptions}
            size='small'
            noOptionsText='No entries'
            id="multiple-limit-tags"
            options={options}
            filterOptions={filterOptions}
            getOptionLabel={(option) => option?.title?.ru?.value || ''}
            renderInput={(params) => (
                <TextField {...params} 
                  placeholder={placeholder}
                  error={getError()}
                />
            )}
        />
        {isHelperText && <FormHelperText error={true} >{getError()||" "}</FormHelperText>}
      </div>
    )
}

const o = observer(OneAutocomplete)
export {o as OneAutocomplete};